import { render, staticRenderFns } from "./AuthorModal.vue?vue&type=template&id=11784bd0&"
import script from "./AuthorModal.vue?vue&type=script&lang=ts&"
export * from "./AuthorModal.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports